/* eslint-disable no-irregular-whitespace */
// eslint-disable-next-line import/prefer-default-export
export const showInsignLog = (packageJson) => {
  console.info(
    `
      %c█ █▄ █ █▀ █ █▀▀ █▄ █ %c▄▄ %c█▀▀ █ █ █
      %c█ █ ▀█ ▄█ █ █▄█ █ ▀█ %c░░ %c█▄█ ▀▄▀▄▀  %cv%s
  
      %c
      @inface-sdk/web-auth: %s
      @inface-sdk/web-game-auth: %s
    `,

    'color: #f39c12',
    'color: #2c3e50',
    'color: #e67e22',

    'color: #f1c40f',
    'color: #2c3e50',
    'color: #d35400',

    'color: #2c3e50; font-weight: bold',
    `${packageJson.version}`,

    'font-weight: normal',
    `${packageJson.dependencies['@inface-sdk/web-auth']}`,
    `${packageJson.dependencies['@inface-sdk/web-game-auth']}`,
  )
}
